<div>
  <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
    <h2 class="cpo-section-title">User Details</h2>
    
    @if (this.showCloseButton) {
      <close-x (click)="close.emit()"></close-x>
    } @else if (this.enableEditing && false) {
      <div [hidden]="editingContact">
        <span class="cpo-edit-link" (click)="btnEditInfo_click(c)">Edit</span>
      </div>
    }
  </div>
  @if (this._currentMode == formMode.View) {
    <div
      style="
        flex: 1;
        padding: 0px 0px 10px 30px;
      "
    >
      <div class="cpo-pod" style="padding-bottom: 0px;">
        <span class="title">{{ selectedRole }}</span>
        <span class="r1">{{ userFormData.firstName }} {{ userFormData.lastName }}</span>
        <div class="r2">
          <span style="text-decoration: underline; text-underline-offset: 2px;">{{ userFormData.emailAddress }}</span>
          <svg width="16" height="16" style="margin-left: 3px; margin-right: 3px;">
            <circle cx="8" cy="13" r="2" fill="var(--green-900)" />
          </svg>
          <span style="text-decoration: underline; text-underline-offset: 2px;">{{ userFormData.phone?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') }}</span>
          @if (userFormData.fax) { 
            <svg width="16" height="16" style="margin-left: 3px; margin-right: 3px;">
              <circle cx="8" cy="13" r="2" fill="var(--green-900)" />
            </svg>
            <span style="text-decoration: underline; text-underline-offset: 2px;">{{ userFormData.fax?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') }}</span>
          }
        </div>
      </div>
    </div>
  } @else {
    <div style="display: flex; align-items: start; gap: 20px">
      <app-textbox
        [label]="'First name'"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="this.userFormData.firstName"
        (ngModelChange)="checkValidity()"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-textbox>
      <app-textbox
        [label]="'Last name'"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="this.userFormData.lastName"
        (ngModelChange)="checkValidity()"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-textbox>
    </div>

    <div>
      <app-textbox
        [type]="TextModes.Email"
        [label]="'Email address'"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="this.userFormData.emailAddress"
        (ngModelChange)="checkValidity()"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-textbox>
    </div>

    <div style="display: flex; align-items: start; gap: 20px">
      <app-textbox
        [label]="'Phone'"
        [type]="TextModes.Phone"
        [required]="true"
        [showRequired]="true"
        [(ngModel)]="this.userFormData.phone"
        (ngModelChange)="checkValidity()"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-textbox>
      <app-textbox
        [label]="'Fax'"
        [type]="TextModes.Phone"
        [required]="false"
        [(ngModel)]="this.userFormData.fax"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-textbox>
    </div>

    <div [hidden]="!enableRoleSelection || !isNew">
      <!-- userFormData.originalRole -->
      <app-selectbox
        [label]="'Role'"
        [required]="enableRoleSelection"
        [(ngModel)]="this.selectedRole"
        [options]="roleOptions"
        (ngModelChange)="checkValidity()"
        [readonly]="
          this._currentMode == formMode.View || userFromSearch != undefined
        "
      ></app-selectbox>
      @if (!user || user.id == '') {
        <div class="note">
          You will have the opportunity to customize this user's access once
          you have created the account.
        </div>
      }
    </div>

  }

</div>
